import React, { useContext } from "react";
import { getAppConfig } from "@config/appConfig";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import { SessionContext } from "@context/SessionContext";
import { UserContext } from "@context/UserContext";
import AlertMessage from "@components/AlertMessage";
import BookedTicketWarning from "@components/Bookings/BookedTicketWarning";
import SessionDetails from "@components/SessionDetails";
import CapRedemptionsAlert from "@components/V3/V3BookSession/CapRedemptionsAlert";
import { getImageAtSize } from "@utils/imageUtils";
import { getVoucherUpgradeDetails } from "@utils/ticketUtils";

const BookSessionDetails = () => {
    const config = getAppConfig();

    const { session } = useContext(SessionContext);
    const { bookedTicketForSession } = useContext(UserContext);

    const fallbackImage = `${config?.cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;
    const upgradeDetails = session ? getVoucherUpgradeDetails(session) : null;

    const onImageError = (e) => {
        e.target.src = fallbackImage;
    };

    const movie = {
        movie_id: session?.movie_id,
        movie_image: session?.movie_image,
        movie_title: session?.movie_title,
    };

    const PosterImage = () => (
        <img
            loading="lazy"
            alt={`${movie.movie_title ? movie.movie_title : movie.title} poster image`}
            src={getImageAtSize(movie.movie_image, 428) || fallbackImage}
            onError={onImageError}
            className="v2v3-booking__img"
            title={movie.movie_title ? movie.movie_title : movie.title}
        />
    );

    return (
        <>
            <div className="v3-booking__info-wrapper">
                <div className="v3-booking__image">
                    <PosterImage />
                </div>
                <SessionDetails session={session} />
            </div>

            {upgradeDetails && (
                <AlertMessage
                    message={upgradeDetails.message}
                    type="info"
                />
            )}

            <CapRedemptionsAlert />

            {bookedTicketForSession.length > 0 && <BookedTicketWarning />}
        </>
    );
};

export default BookSessionDetails;
